import React from 'react';
import styled from 'styled-components';
import doubleQuotesIcon from './double-quotes.svg';
import starIcon from './ic_round-star.svg';

export type LectureReview = {
  id: number;
  rating: number;
  content: string;
};

interface LectureReviewCardProps {
  review: LectureReview;
}

function LectureReviewCard({ review }: LectureReviewCardProps) {
  return (
    <StyledContainer>
      <div className='review-header'>
        <div className='review-rating'>
          {Array(review.rating)
            .fill(0)
            .map((_, index) => (
              <img key={index} src={starIcon} alt='star-icon' />
            ))}
        </div>
        <div>
          <img src={doubleQuotesIcon} alt='double-quotes-icon' />
        </div>
      </div>
      <p className='review-content'>{review.content}</p>
    </StyledContainer>
  );
}

const StyledContainer = styled.article`
  width: 100%;
  height: 230px;
  padding: 30px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;

  > .review-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  > .review-content {
    margin-top: 24px;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 400;
    color: #555;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default LectureReviewCard;
